import { isBrowser } from '@croquiscom/web2app';

import { checkZPayFunctionExists } from '@common/log-manager';

import { Route, routes } from './Route';

import { ParsedUrlQuery } from 'querystring';
import { parse, UrlObject, UrlWithParsedQuery } from 'url';

export const match = (url: string | UrlObject) => {
  const parsedUrl = typeof url === 'string' ? parse(url, true) : (url as UrlWithParsedQuery);
  const { pathname, query } = parsedUrl;
  return routes.reduce<{ query: ParsedUrlQuery; parsedUrl: UrlWithParsedQuery; route?: Route }>(
    (result, route) => {
      if (result.route) {
        return result;
      }
      const params = route.match(pathname!);
      if (!params) {
        return result;
      }
      return { ...result, route, params, query: { ...query, ...params } };
    },
    { query, parsedUrl },
  );
};

export const hasHashInUrl = () => {
  return window.location.href.indexOf('#') >= 0;
};

export const getUrlByPath = (pathname: string) => {
  if (isBrowser()) {
    pathname =
      checkZPayFunctionExists(window) || document.referrer.indexOf(`${window.location.origin}/app`) >= 0
        ? `/app${pathname}`
        : pathname;
    return `${window.location.origin}${pathname}`;
  }
  return pathname;
};
